import { render, staticRenderFns } from "./safeAlarmHandler.vue?vue&type=template&id=0a058efd&scoped=true"
import script from "./safeAlarmHandler.vue?vue&type=script&lang=js"
export * from "./safeAlarmHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a058efd",
  null
  
)

export default component.exports